import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LogOut, AlertCircle } from 'lucide-react';

import { selectSessionExpired, selectSessionExpiredReason } from '../../redux/user/user.selectors';
import { clearSessionExpired } from '../../redux/user/user.actions';
import { setCurrentDistro } from '../../redux/distro/distro.actions';

const SessionExpiredModal = ({ sessionExpired, sessionExpiredReason, clearSessionExpired, setCurrentDistro }) => {
    const history = useHistory();
    const accessChanged = sessionExpiredReason === 'accessChanged';

    // clear localStorage when session expires
    useEffect(() => {
        if (sessionExpired) {
            localStorage.clear();
        }
    }, [sessionExpired]);

    const handleSignIn = () => {
        clearSessionExpired();
        setCurrentDistro(null);
        history.push('/signin');
    };

    if (!sessionExpired) return null;

    return (
        <>
            {/* backdrop */}
            <div
                className="fixed inset-0 bg-black/50 z-[100]"
                aria-hidden="true"
            />

            {/* modal */}
            <div
                className="fixed inset-0 z-[101] flex items-center justify-center p-4"
                role="dialog"
                aria-modal="true"
                aria-labelledby="session-expired-title"
            >
                <div className="bg-white rounded-2xl shadow-modal w-full max-w-sm overflow-hidden animate-slide-up">
                    {/* content */}
                    <div className="px-6 py-8 text-center">
                        <div className="w-16 h-16 bg-amber-50 rounded-full flex items-center justify-center mx-auto mb-4">
                            <AlertCircle className="w-8 h-8 text-amber-500" />
                        </div>
                        <h2 id="session-expired-title" className="text-xl font-semibold text-gray-900 mb-2">
                            {accessChanged ? 'Access Changed' : 'Session Expired'}
                        </h2>
                        <p className="text-gray-500 text-sm mb-6">
                            {accessChanged
                                ? 'Your firm access has changed. Please sign in again to continue.'
                                : 'Your session has expired. Please sign in again to continue.'}
                        </p>
                        <button
                            onClick={handleSignIn}
                            className="w-full bg-primary text-white py-3 px-6 rounded-full font-semibold text-base shadow-sm hover:bg-primary-dark active:scale-[0.98] transition-all duration-200 inline-flex items-center justify-center gap-2"
                        >
                            <LogOut className="w-5 h-5" />
                            Sign In Again
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = createStructuredSelector({
    sessionExpired: selectSessionExpired,
    sessionExpiredReason: selectSessionExpiredReason,
});

const mapDispatchToProps = (dispatch) => ({
    clearSessionExpired: () => dispatch(clearSessionExpired()),
    setCurrentDistro: (distro) => dispatch(setCurrentDistro(distro)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionExpiredModal);
